import type {PinnableAspectRatio} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-aspect-ratio-selector/ai-prompt-box-aspect-ratio-selector.types';
import {AspectRatioOrientation} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-actions/ai-prompt-box-aspect-ratio-selector/ai-prompt-box-aspect-ratio-selector.types';

export interface AspectRatioPopupProps {
  pinnedAspectRatio: PinnableAspectRatio | null;
  onRatioSelect: (ratio: PinnableAspectRatio | null) => void;
}

export interface AspectRatioOrientationItem {
  orientation: AspectRatioOrientation;
  labelKey: string;
}

export const ORIENTATION_ITEMS: AspectRatioOrientationItem[] = [
  {orientation: AspectRatioOrientation.PORTRAIT, labelKey: 'pmwjs_portrait'},
  {orientation: AspectRatioOrientation.LANDSCAPE, labelKey: 'pmwjs_landscape'},
];

export const ORIENTATION_GROUP_KEY = 'orientation';
export const ASPECT_RATIO_GROUP_KEY = 'aspect-ratio';
export const ASPECT_RATIO_AUTO_VALUE = 'auto';
